import React from 'react'

const BackHome = (props) => (
    <section>
        <div className="inner">
            <a href="/" className="button fit">powrót do strony głównej</a> 
        </div>
    </section> 
)

export default BackHome
